<template>
    <v-dialog v-model="dialog" persistent max-width="400" min-width="350" scrollable>
        <template v-slot:activator="{ on }">
            <v-btn color="awesome" text  v-on="on">
                <v-icon class="pr-2">mdi-plus-outline</v-icon>
                Add
            </v-btn>
        </template>
        <v-card>
            <Lbls>views/a4l/NewAthlete.vue</Lbls>
            <v-card-title v-if="state==='search'">
                <v-row>
                    <v-col xs="12" sm="12" md="12" class="py-0">
                        Search Player
                        <v-btn class="float-right" style="text-transform: none" text
                               @click="state='newfrompin',search='',searchedplayers=false">Enter PIN</v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="state!=='creating'">
                    <v-col class="py-0">
                        <v-text-field
                                @input="searchProfiles()"
                                outlined
                                :label="`Search Player Name`"
                                v-model="search"
                                :loading="loading"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-title v-if="state==='newfrompin'">
                <v-row>
                    <v-col>
                        Enter Pin
<!--                        UN-COMMENT FOR FULL FEATURES and uncomment LINE 306-->
<!--                        <v-btn-->
<!--                            class="float-right"-->
<!--                            text-->
<!--                            style="text-transform: none"-->
<!--                            @click="state='search'"-->
<!--                        >-->
<!--                            Search Players-->
<!--                        </v-btn>-->
                    </v-col>
                </v-row>
                <v-row>
                    <v-col xs="3" >
                        <div class="pindiv">
                            <input ref="i0" @focus="$refs.i0.select()"  @input="$refs.i1.focus()" v-model="pin[0]" class="pininput" />
                        </div>
                    </v-col>
                    <v-col xs="3">
                        <div class="pindiv">
                            <input ref="i1" @focus="$refs.i1.select()"  @input="$refs.i2.focus()" v-model="pin[1]" class="pininput" />
                        </div>
                    </v-col>
                    <v-col xs="3">
                        <div class="pindiv">
                            <input ref="i2" @focus="$refs.i2.select()"  @input="$refs.i3.focus()" v-model="pin[2]" class="pininput" />
                        </div>
                    </v-col>
                    <v-col xs="3">
                        <div class="pindiv">
                            <input ref="i3" @focus="$refs.i3.select()"   v-model="pin[3]" class="pininput" />
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-title v-if="state==='creating'">Create new Athlete</v-card-title>
            <v-card-text>
                <span class="red--text" v-if="errormessage">{{errormessage}}</span>
                <v-row v-if="searchedfirst && state==='search'">
                    <v-col class="py-0">
                        <BaseBtn
                                block
                                @click="createNewClick()"
                                :disabled="!!newathlete"
                                :loading="loading"
                        >
                            Create New
                        </BaseBtn>
                    </v-col>
                </v-row>
                <!--Select Participant List-->
                <v-row>
                    <v-list v-if="state==='search'">
                        <v-list-item v-for="p in searchedplayers" :key="p.partkey" @click="newathlete=p,confirmaddplayerdialog=true">
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{p.firstname}} {{p.lastname}}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-row>
                <!--Add Participant Form-->
                <v-row v-if="newathlete">
                    <v-col cols="12">
                        <v-form v-model="valid" ref="addplayerform" lazy-validation>
                        <v-text-field
                                :readonly="readonly"
                                outlined
                                label="First Name"
                                :rules="required"
                                v-model="athlete.newfirstname"
                        ></v-text-field>
                        <v-text-field
                                :readonly="readonly"
                                outlined
                                :rules="required"
                                label="Last Name"
                                v-model="athlete.newlastname"
                        ></v-text-field>
                        <v-text-field
                                :readonly="readonly"
                                outlined
                                label="Gradyear"
                                :rules="gradrules"
                                :counter="4"
                                v-model="athlete.newgradyear"
                        ></v-text-field>
                        <v-text-field
                                :readonly="readonly"
                                outlined
                                label="Email - not required"
                                :rules="[$store.state.rules.emailRules]"
                                v-model="athlete.email"
                        ></v-text-field>
                        <v-text-field
                                :readonly="readonly"
                                outlined
                                label="Cell - not required"
                                :rules="[$store.state.rules.cellRules]"
                                v-model="athlete.cell"
                        ></v-text-field>
                        </v-form>
                        <BaseBtn text small :disabled="!newathlete" @click="newathlete=false,search='',state='search',searchedfirst=false">Reset</BaseBtn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <BaseBtn
                        text
                        @click="closeAndClean()"
                >
                    Cancel
                </BaseBtn>
                <v-spacer></v-spacer>
                <BaseBtn
                        v-if="newathlete"
                        :disabled="!valid"
                        @click="playerCreate() "
                >
                    Save
                </BaseBtn>
                <BaseBtn ref="getpin" v-if="state==='newfrompin'" :disabled="pin.length<4" :loading="loading" @click="getAthleteByPin()">
                    Get
                </BaseBtn>
            </v-card-actions>
        </v-card>
        <v-dialog v-model="confirmaddplayerdialog" max-width="500">
            <v-card>
                <v-card-title>
                    Confirm Add
                </v-card-title>
                <v-card-text class="title">
                    Add {{newathlete.firstname}} {{newathlete.lastname}}  ?
                    <!--PIN {{newathlete.pin}}-->
                </v-card-text>
                <v-card-actions>
                    <BaseBtn text @click="cancelAdd()">Cancel</BaseBtn>
                    <v-spacer></v-spacer>
                    <BaseBtn @click="confirmAdd()" :loading="loading">Confirm</BaseBtn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
    //
  import {
    mapActions,
    mapState
  } from 'vuex'
  import BaseBtn from "@/components/BaseBtn";
    import Lbls from "../../components/Lbls";

  const PLAYER = {
    newfirstname: '',
    newlastname: '',
    newgradyear: '',
    email: '',
    phone: '',
    shirtsize: '',
    readonly: false
  }

  export default {
    name: "NewAthlete",
    components: {Lbls, BaseBtn},
    data: () => ({
      valid:false,
      state: 'newfrompin', // 'search',//or newfrompin or createnew
      errormessage: undefined,
      saving: false,
      newathlete: false,
      newfrompin:false,
      pin: [],
      athlete: false,
      index: [0],
      search: '',
      dialog: false,
      searchedplayers: false,
      readonly: false,
      isFilled: undefined,
      canClear: false,
      loading:false,
      searchedfirst:false,
      confirmaddplayerdialog:false,
      required: [v => !!v || 'Required'],
      gradrules: [v => { if(v) { return (v && (v.length === 4 && /^[0-9]/.test(v))) || '4 year gradyear' } else {return true}}]
    }),
    computed: {
      ...mapState(['sportcode',  'registrants', 'step', 'myathletes','permissions'])
    },
    watch:{
      permissions(n){
        if(this.$prms(['director','admin'])){
          this.state='search'
        }
      }
    },
    mounted() {
        if(this.$prms(['director','admin'])){
          this.state='search'
        }
    },
    methods: {
      ...mapActions(['post', 'get', 'delete', 'put']),
      async getAthleteByPin() {
        this.errormessage=undefined
        let pin = this.pin.join('')
        console.log(pin)
        if (pin.length !== 4){
          this.errormessage='PIN is 4 digits'
          return
        }
        this.loading=true
        let a = await this.get({path:'api/profilesv2/newathletefrompin/'+pin})
        this.loading=false
        if(a.error)return this.errormessage=a.error.message
        this.newathlete = a
        this.confirmaddplayerdialog = true //load the confirm add dialog
      },
      async newAthleteFromPin() {
        let body={
          newathletekey:this.newathlete.partkey
        }
        this.loading=true
        let cp = await this.post({path:'api/profilesv2/newathletefrompin',body:body})
        this.loading=false
        console.log(cp)
        return cp
      },
      async newPlayer() {
        this.athlete = Object.assign({}, PLAYER)
        this.athlete.sportcode = this.sportcode
      },
      async searchProfiles() {
        this.searchedfirst = true;
        this.loading=true
        if(this.search===''){
          this.searchedplayers=[]
          this.loading=false
          return;
        }
        //jon sprouse john.sprouse@angi.com
        let data = {
          search: this.search
        }
        //todo add ._throttle, maybe?
        let p = await this.post({body: data, path: 'api/profilesv2/searchprofiles'})
        this.searchedplayers = p
        this.loading=false
      },
      async playerCreate()  {
        console.log('ATHLETE:', this.athlete)
        if (this.$refs.addplayerform.validate()){
          let data = {
            email: this.athlete.email,
            newfirstname: this.athlete.newfirstname,
            newlastname: this.athlete.newlastname,
            newgradyear: this.athlete.newgradyear,
            sportcode: this.sportcode,
            //org will be handled by orgauth
          }
          let p = await this.post({path: 'api/profilesv2/create', body: data})
          if (p.error) return;
          this.athlete = p
          this.closeAndClean()
          //todo add new athlete to list
          return;
        }
        this.playerdialog = false
        this.search = ''
        this.players[this.index] = this.athlete
        this.index = -1;
        this.newathlete = false
        this.verifyTeam()
      },
      async closeAndClean(){
        this.dialog=false;
        this.searchedplayers=false;
        this.index=-1;
        this.newathlete=false;
        this.search='';
        this.pin=[];
        this.state='newfrompin',// 'search';
        this.searchedfirst=false
        this.valid=false
      },
      async createNewClick(){
        this.newathlete=true
        this.searchedplayers=false
        this.readonly=false
        this.state='creating';
        this.newPlayer()
        let names = this.search.split(' ')
        console.log(this.search,names)
        this.athlete.newfirstname = names[0]
        this.athlete.newlastname = names[1]||''
      },
      async selectPlayer(p){
        this.$emit('participant',p)
        this.dialog=false
        this.searchedplayers=false
        this.search=''
      },
      async confirmAdd(){
        console.log('Step1')
        await this.newAthleteFromPin() //add it to our myplayers list
        console.log('Step2')
        this.$emit('participant',this.newathlete)
        this.closeAndClean()
      },
      async cancelAdd(){
        this.confirmaddplayerdialog = false;
        this.newathlete = false
        this.pin=[]
      }
    }
  }
</script>

<style scoped>
    .pindiv{
        border:solid thin #888888;
        padding:3px;
        border-radius: 3px;
    }
    .pininput{
        width:100%;
        height:2.5em;
        text-align: center;
        text-transform: uppercase;
    }
</style>